import { AccountSettingsPayload } from '@account-users/account/models/AccountSettingsPayload';
import { IAccount } from '@account-users/account/models/IAccount';
import { LicensePackage } from '@account-users/account/models/License';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { FormState } from '@shared';

@Component({
  selector: 'app-confirm-package-modal',
  templateUrl: './confirm-package-modal.component.html',
  styleUrls: ['./confirm-package-modal.component.scss'],
})
export class ConfirmPackageModalComponent {
  @Input() state: FormState;
  @Input() accountDetails: IAccount = null;
  @Input() licensePackages: LicensePackage[] = [];
  @Input() order: AccountSettingsPayload = null;
  @Output() confirmationResult = new EventEmitter();
  errorResponse: HttpErrorResponse;
  formStates = FormState;

  get licensePackage() {
    return this.licensePackages.find(
      (p) => p.code === this.accountDetails?.licensePackage,
    );
  }

  get switchToPackage() {
    return this.licensePackages.find(
      (p) => p.code === this.order?.licensePackage,
    );
  }

  constructor(public activeModal: NgbActiveModal) {}

  onConfirm() {
    this.confirmationResult.emit();
  }
}
